import { useTranslate } from "@refinedev/core";
import { List } from "@refinedev/antd";
import { Button, Space, Tabs } from "antd";
import { ExperiencesTable } from "./tables/experiences";
import { useAntTheme } from "hooks/useAntTheme/";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CaretLeftIcon } from "@phosphor-icons/react";
import styled from "styled-components";
import { getCoverImage } from "./helpers/workspaceImages";
import {
  toNegativeCssBox,
  usePagePadding,
} from "components/layout/pagePadding";

export const WorkspacesDetailPage = () => {
  const t = useTranslate();
  const navigate = useNavigate();
  const { theme } = useAntTheme();
  // Full-bleed page (cover image to the edges): cancels the app shell's page
  // padding.
  const pagePadding = usePagePadding();
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const { workspaceName } = location.state || {};

  const handleBack = () => navigate("/workspaces");
  const wrapperProps = {
    style: {
      backgroundColor: theme.colorSurfaceBG,
      margin: toNegativeCssBox(pagePadding),
      padding: 0,
      position: "relative" as const,
    },
  };
  return (
    <List
      breadcrumb={<></>}
      headerButtons={<></>}
      wrapperProps={wrapperProps}
      title={<></>}
    >
      {id && <CoverImage aria-hidden $background={getCoverImage(id)} />}
      <ContentWrapper $hasCover={!!id}>
        <StyledHeader>
          <h1>{workspaceName}</h1>
        </StyledHeader>
        <Space direction="horizontal" align="start">
          <ButtonBack type="text" icon={<CaretLeftIcon />} onClick={handleBack}>
            {t("media.workspaces.backToWorkspaces")}
          </ButtonBack>
        </Space>
        <StyledTabs
          defaultActiveKey="1"
          items={[
            {
              key: "1",
              label: t("media.workspaces.tabs.experiences"),
              children: <ExperiencesTable />,
            },
            // TODO: wait for the BE to have an api that filters members by workspace
            // {
            //   key: "2",
            //   label: t("media.workspaces.tabs.members"),
            //   children: <MembersTable />,
            // },
          ]}
        />
      </ContentWrapper>
    </List>
  );
};

const ButtonBack = styled(Button)`
  padding: 0;
  color: ${({ theme }) => theme.colorTextBaseRedesign};
  font-size: 18px;
  margin: 15px 0 15px -6px;
`;

const CoverImage = styled.div<{ $background?: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 200px;
  background: ${({ $background }) => $background};
`;

const ContentWrapper = styled.div<{ $hasCover: boolean }>`
  padding: 24px;
  padding-top: ${({ $hasCover }) => ($hasCover ? "160px" : "24px")};
`;

const StyledHeader = styled.div`
  h1 {
    font-size: 24px;
    font-weight: 500;
    color: #0f1724;
    margin-bottom: 0;
    text-transform: capitalize;
  }

  /* TODO: add a description of the workspace */
  span {
    font-size: 16px;
    font-weight: 400;
    color: #6b7280;
  }
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav-wrap {
    * {
      color: #6b7280 !important;
    }
  }
  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      color: #0f1724 !important;
    }
  }
  .ant-tabs-ink-bar {
    background-color: #0f1724;
  }
`;
